import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vti-separator',
  template: `<div class="border-b border-gray-900/10"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class SeparatorComponent {}
